<template>
    <div>
        <validation-observer ref="dropdownForm">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <div class="drop-down-attribute">
                    <label :for="id" :class="{' col-md-3 col-xs-4 ' : isInquiry , 'attribute-label' : !isInquiry}">
                        {{ question.question_text }}
                    </label>
                    <validation-provider v-slot="{errors}" :rules="question.mandatory ? 'required' : ''">
                        <div :class="{' col-md-9 col-xs-8' : isInquiry}">
                            <select :id="id" v-model="question.value" :name="name" @change="updateDropDown"
                                    class="form-control new-inputs height-48">
                                <option :value="null" disabled selected>Select One</option>
                                <option v-for="(option,index) of question.options" :value="option.id">
                                    {{ option.option }}
                                </option>
                            </select>
                            <input type="hidden" :value="id" name="questions[]">
                            <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                            <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>
                        </div>
                    </validation-provider>
                </div>
            </div>
        </validation-observer>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormDropDown",
    props: {
        value:{},
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    components: {
        ValidationObserver,
        ValidationProvider
    },
    data() {
        return {
            question:this.value
        }
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {
        updateDropDown(){
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry( this.question.value, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }
        },
        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.dropdownForm){
                    let validated = await this.$refs.dropdownForm.validate();
                    verify(validated)
                }
            })

        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        selectOption(){
            // Set the selected value to the id of the option that matches answer_text
            const matchingOption = this.question.options.find(option => option.id == this.question.answer_text);
            if (matchingOption) {
                this.question.selected = matchingOption.id;
                this.question.value = this.question.selected;
            }
        }
    },
    mounted() {
        this.addEventListeners()
        this.selectOption()
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners()
    }
}
</script>

<style scoped>
.p-0-1{
    padding:0px 1px;
}

@media screen and (min-width: 768px) and (max-width: 1440px) {
    .change-form-list-in-inquiry {
         margin-left: 15px !important;
    }
}

@media screen and (min-width: 1px) and (max-width: 428px) {
    /*@media only screen and (max-width: 428px) {*/
    .change-form-list-in-inquiry {
        width: 57%;
        margin-left: 15px !important;
    }
}

@media screen and (min-width: 1441px) {
    .change-form-list-in-inquiry {
        margin-left: 17px !important;
    }
}
</style>